/* Panache shirt designer (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function money(c) { var f = (window.theme && window.theme.moneyFormat) || '${{amount}}'; var v = (c / 100).toFixed(2); var p = v.split('.'); var w = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1]; return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, p[0]).replace(/\{\{\s*amount\s*\}\}/, w).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  function init(root) {
    var form = $('[data-dz-form]', root); if (!form) return;
    var P = JSON.parse($('[data-dz-product]', root).textContent);
    var steps = $$('.dz-step', form), errEl = $('[data-dz-error]', form);
    var bar = document.querySelector('[data-dz-bar]');

    function val(name) { var c = $('input[name="properties[' + name + ']"]:checked:not(:disabled)', form); if (c) return c.value; var s = $('select[name="properties[' + name + ']"]', form); return s ? s.value : ''; }
    function cond(expr) {
      var m = expr.match(/^([^=~]+)([=~])(.*)$/); if (!m) return true;
      var v = val(m[1]);
      if (m[2] === '=') return v === m[3];
      return m[3].split('|').some(function (x) { return v.indexOf(x) > -1; });
    }
    function applyConditions() {
      $$('[data-show-if]', form).forEach(function (el) {
        var on = cond(el.getAttribute('data-show-if'));
        var p = el.parentElement.closest('[data-show-if]');
        if (p && p.hidden) on = false;
        el.hidden = !on;
        $$('input,select,textarea', el).forEach(function (i) { i.disabled = !on; });
      });
      // nested: re-run once so children of re-shown parents follow their own rule
      $$('[data-show-if] [data-show-if]', form).forEach(function (el) {
        var p = el.parentElement.closest('[data-show-if]');
        var on = !p.hidden && cond(el.getAttribute('data-show-if'));
        el.hidden = !on; $$('input,select,textarea', el).forEach(function (i) { i.disabled = !on; });
      });
    }
    function extras() {
      return $$('[data-price]', form).filter(function (i) { return !i.disabled && i.checked; });
    }
    function total() {
      var q = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
      var add = extras().reduce(function (a, i) { return a + parseInt(i.getAttribute('data-price'), 10); }, 0);
      $$('[data-dz-total]').forEach(function (el) { el.textContent = money((P.price + add) * q); });
      var n = $('[data-dz-extras-note]', root); if (n) n.textContent = add ? ' + options ' + money(add) : ''; var nw = n && n.closest('.dz-price__note'); if (nw) nw.hidden = !add;
    }
    function labels() {
      $$('.dz-group', form).forEach(function (g) { var c = $('input:checked', g), o = $('.dz-val', g); if (o) o.textContent = c && !c.disabled ? c.value : ''; });
      steps.forEach(function (s) {
        var parts = $$('input:checked:not([data-remember]), select', s).filter(function (i) { return !i.disabled && i.value && i.type !== 'checkbox'; }).slice(0, 3).map(function (i) { return i.value; });
        var o = $('[data-dz-sum]', s); if (o) o.textContent = parts.join(' · ');
      });
      var list = $('[data-dz-list]', form);
      if (list) {
        var h = '';
        $$('[name^="properties["]', form).forEach(function (i) {
          if (i.disabled || i.type === 'hidden' || ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) || !(i.value || '').trim()) return;
          if (i.closest('[data-dz-step="7"]')) return;
          var k = i.name.slice(11, -1); var v = i.value + (i.hasAttribute('data-price') ? ' (+' + money(+i.getAttribute('data-price')) + ')' : '');
          h += '<dt>' + k.replace(/</g, '&lt;') + '</dt><dd>' + v.replace(/</g, '&lt;') + '</dd>';
        });
        list.innerHTML = h;
      }
    }
    function validate(scope) {
      var ok = true, first = null, seen = {};
      $$('[data-req]', scope).forEach(function (el) {
        if (el.disabled || el.closest('[data-show-if][hidden]')) return;
        var bad;
        if (el.type === 'radio') { if (seen[el.name]) return; seen[el.name] = 1; bad = !$$('input[name="' + el.name + '"]', scope).some(function (r) { return r.checked; }); }
        else bad = !(el.value || '').trim();
        var host = el.closest('.dz-mfield') || el.closest('.field') || el.closest('.dz-group');
        if (host) host.classList.toggle('has-error', bad);
        if (bad) { ok = false; if (!first) first = el; }
      });
      if (first) {
        var st = first.closest('.dz-step'); if (st) open(st, true);
        (first.closest('.dz-mfield') || first.closest('.field') || first.closest('.dz-group')).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (errEl) { errEl.textContent = (window.theme && window.theme.strings && window.theme.strings.required) || 'Please complete the required fields.'; errEl.classList.add('is-visible'); }
      } else if (errEl) errEl.classList.remove('is-visible');
      return ok;
    }
    function open(step, noScroll) {
      steps.forEach(function (s) { var on = s === step; $('.dz-step__body', s).hidden = !on; $('[data-dz-toggle]', s).setAttribute('aria-expanded', on); });
      if (!noScroll) { var top = step.getBoundingClientRect().top + window.scrollY - 90; window.scrollTo({ top: top, behavior: 'smooth' }); }
      var i = steps.indexOf(step); var pr = bar && $('[data-dz-progress]', bar); if (pr) pr.textContent = 'Step ' + (i + 1) + ' of ' + steps.length;
    }
    steps.forEach(function (s, i) {
      $('[data-dz-toggle]', s).addEventListener('click', function () { var b = $('.dz-step__body', s); if (!b.hidden) { b.hidden = true; this.setAttribute('aria-expanded', false); } else open(s, true); });
      var nx = $('[data-dz-next]', s);
      if (nx) nx.addEventListener('click', function () { if (validate(s)) { s.classList.add('is-done'); open(steps[i + 1]); } });
    });

    // initials
    var ini = $('[data-initials]', form);
    if (ini) ini.addEventListener('input', function () { ini.value = ini.value.replace(/[^a-zA-Z.&]/g, '').toUpperCase().slice(0, 3); });
    // remembered measurements
    var saved = store('panache_dz_measure');
    if (saved) $$('input[data-measure]', form).forEach(function (i) { var k = i.getAttribute('data-measure'); if (saved[k] && !i.value) i.value = saved[k]; });

    form.addEventListener('change', function () { applyConditions(); total(); labels(); });
    form.addEventListener('input', function (e) { if (e.target.name === 'quantity') total(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]') && form.contains(e.target)) setTimeout(total, 0); });

    if (bar) {
      bar.hidden = false;
      $('[data-dz-jump]', bar).addEventListener('click', function () {
        var cur = steps.filter(function (s) { return !$('.dz-step__body', s).hidden; })[0] || steps[0];
        var btn = $('[data-dz-next]', cur);
        if (btn) btn.click(); else $('[data-dz-atc]', form).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) return;
      var rem = $('[data-remember]', form);
      if (rem && rem.checked && !rem.disabled) { var d = {}; $$('input[data-measure]', form).forEach(function (i) { if (i.value) d[i.getAttribute('data-measure')] = i.value; }); store('panache_dz_measure', d); }
      var q = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
      var props = {};
      $$('[name^="properties["]', form).forEach(function (i) {
        if (i.disabled) return; if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
        var v = (i.value || '').trim(); if (v) props[i.name.slice(11, -1)] = v;
      });
      if (props.Unit && !/measurements|favourite/.test(props.Sizing || '')) delete props.Unit;
      var grp = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
props._group = grp;
var items = [];
extras().forEach(function (i) { items.push({ id: parseInt(i.getAttribute('data-extra'), 10), quantity: q, properties: { _for: P.title, _group: grp } }); });
items.push({ id: parseInt($('input[name="id"]', form).value, 10), quantity: q, properties: props });
      var btn = $('[data-dz-atc]', form); btn.classList.add('is-loading'); btn.disabled = true;
      var C = window.PanacheCart;
      C.add(items).then(function () { return (window.theme && window.theme.cartDrawer) ? C.refresh(true) : (window.location.href = window.theme.routes.cart_url); })
        .catch(function (err) { if (errEl) { errEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errEl.classList.add('is-visible'); } })
        .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    });

    applyConditions(); total(); labels();
  }
  function boot() { $$('[data-dz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
